// extracted by mini-css-extract-plugin
module.exports = {"qustions":"_bN","button_next_page":"_bO","pagination_categories":"_bP","mobile_banner":"_bQ","ad_wrapper":"_bR"};